import type { ChatArtifact } from '@axilon-apps/domains-ontology-ui-state'

export const DELETED_DOCUMENT_MESSAGE = 'This document was deleted.'

export type DocumentArtifactBody =
  | { kind: 'deleted' }
  | { kind: 'markdown'; text: string }
  | { kind: 'file'; documentId: string; revisionId?: string; format: string }

/**
 * What a document artifact shows: its markdown, its stored Word / Excel / CSV /
 * PDF file at the revision the chat pins, or nothing once its document is
 * deleted.
 */
export function documentArtifactBody(
  artifact: Pick<ChatArtifact, 'code' | 'document_id' | 'format' | 'revision_id'>
): DocumentArtifactBody {
  if (!artifact.document_id) return { kind: 'deleted' }
  const format = (artifact.format ?? '').trim().toLowerCase()
  if (format === '' || format === 'md') return { kind: 'markdown', text: artifact.code }
  return {
    kind: 'file',
    documentId: artifact.document_id,
    format,
    ...(artifact.revision_id ? { revisionId: artifact.revision_id } : {})
  }
}
